export * from './src/payments-tax-documents-v1-tax-document-tax-documents.universal.js';
